module.exports = __webpack_public_path__ + "img/H-63-ER-750-B.c1927165.png";